import React from 'react';

const StepperFooter = ( { currentScore, goBack, stepResults } ) => {
    return (
        <footer className="finder-footer text-center pt-2">
            <div><button className={`btn btn-${stepResults ? 'link' : 'primary'} ${goBack ? 'opacity-1' : 'opacity-0'}`} onClick={goBack}>{stepResults ? 'Neu starten' : 'Vorige Frage'}</button></div>
            {currentScore && <div className="small text-muted" style={{opacity: 0}}>Score: {currentScore}</div>}
        </footer>
    )
}

StepperFooter.defaultProps = {
    currentScore: null,
    goBack: null,
    stepResults: false,
}

export default StepperFooter
